// Admin routes for P6-A (PAYMENT-01/03/05/08/09, FINANCE-01/03/04). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1 and the nav tree (shell/nav.ts "money" group):
//   money            FINANCE-01 cash book, accounts and journal
//   money/cod        FINANCE-03 COD remittances and shortfalls
//   money/accounts   FINANCE-01 Cash and bank (money accounts, every ledger account)
//   money/expenses   FINANCE-01 expenses by category (owner, 2026-10-22: built on the ledger)
//   money/suppliers  FINANCE-01 suppliers and payables (bills, payments, statements)
//   money/statements FINANCE-01 profit & loss, balance sheet, trial balance
// The payment-method gateways, online payment attempts, settlements, deposits and refunds are tabs
// and actions on money/payments (apps/admin/src/payments/PaymentsPage.tsx, routed by the commerce
// module since Phase 5).
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../finance/CashBankPage");
const CashBankPage = lazyRouteComponent(load1, "CashBankPage");
const load2 = () => import("../finance/CodPage");
const CodPage = lazyRouteComponent(load2, "CodPage");
const load3 = () => import("../finance/ExpensesPage");
const ExpensesPage = lazyRouteComponent(load3, "ExpensesPage");
const load4 = () => import("../finance/FinancePage");
const FinancePage = lazyRouteComponent(load4, "FinancePage");
const load5 = () => import("../finance/StatementsPage");
const StatementsPage = lazyRouteComponent(load5, "StatementsPage");
const load6 = () => import("../finance/SuppliersPage");
const SuppliersPage = lazyRouteComponent(load6, "SuppliersPage");
const load7 = () => import("../payments/MethodsPage");
const PaymentMethodsPage = lazyRouteComponent(load7, "PaymentMethodsPage");

export function paymentsRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    at("/$org/$store/money", FinancePage),
    at("/$org/$store/money/accounts", CashBankPage),
    at("/$org/$store/money/cod", CodPage),
    at("/$org/$store/money/expenses", ExpensesPage),
    at("/$org/$store/money/suppliers", SuppliersPage),
    at("/$org/$store/money/statements", StatementsPage),
    // Apps → Payments (owner, 2026-10-23): the payment methods as cards (was Coming soon).
    at("/$org/$store/apps/payments", PaymentMethodsPage),
  ];
}
